import React from 'react';
import { SnsAccountManagement } from '@/widgets/sns-account-management';

export const SnsAccountManagementPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <SnsAccountManagement />
    </div>
  );
};